import Breadcrumb from "../../../components/breadcrumb";

function JugadoresHeader() {
    return (
        <header className="mb-6 sm:mb-8">
            <Breadcrumb
                items={[
                    { label: "Inicio", to: "/" },
                    { label: "Jugadores", isCurrent: true },
                ]}
                className="mb-4"
            />

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-2 sm:mb-3 border-l-4 border-red-500 pl-4">
                Jugadores
            </h1>
            <p className="text-slate-400 font-medium text-base sm:text-lg max-w-3xl pl-4">
                Explorá el historial de jugadores del Club Atlético Aguada y accede al perfil individual de cada uno.
            </p>
        </header>
    );
}

export default JugadoresHeader;
